var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"appear":""}},[_c('v-icon',{staticClass:"loadingIcon",attrs:{"x-large":""}},[_vm._v("mdi-loading mdi-spin")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }